import { useState, useRef } from "react"
import { translation } from "../../../helper/translation"
import { mailModel } from "../../../model/mailModel"
import axios from "axios";
import { mailResult } from "../../../model/mailResult";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";
import React from "react";

export const ContentContactPageContact = () => {

    const [mail, setMail] = useState<mailModel>(new mailModel());
    const recaptcha = useRef(null)
    const sendMail =() => {
          axios.post('https://mailer.enginkaya.com/send-email', JSON.stringify(mail))
          .then(function (response) {
            let res: mailResult = response.data;
            if(res.status === "SUCCESS")
            {
                setMail({...mail, name: '', email:'', phone: '', subject: '', message: ''});
                toast.success(translation("mail-send-successfully"));
            }
          })
          .catch(function (error) {
                toast.error(translation("there-is-an-error-occured"));
          });
    }
    
    function onChange(value:any) {
        //console.log("Captcha value:", value);
        setMail({...mail, captcha: value});
      }
    
    return(
        <div className="contest-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="top-content">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span className="open">{translation("contact")}</span>
                                    <span className="open">{translation("e-mail")}</span>
                                    <span className="open">{translation("phone")}</span>
                                    <span className="open">{translation("address")}</span>
                                    {/* <span className="wish-list"><i className="fa fa-heart"></i> Add To Your Favorites</span> */}
                                </div>
                            </div>
                        </div>
                        <section className="contact-us">
                        <div className="container">
                        <div className="row">
                            {/* <div className="col-lg-12">
                                <div className="section-heading text-center">
                                    
                                    <h4>Don't Be Shy <em></em> to contact the <em>Photographer Now</em></h4>
                                </div>
                            </div> */}
                            <div className="col-lg-4">
                                <div className="info-item">
                                    <i className="fa fa-phone"></i>
                                    <h4>{translation("phone-number")}</h4>
                                    <span><a href="tel:+4369910646156">+43 699 10646156</a></span>
                                </div>  
                            </div>
                            <div className="col-lg-4">
                                <div className="info-item">
                                    <i className="fa fa-envelope"></i>
                                    <h4>{translation("e-mail-address")}</h4>
                                    <span><a href="mailto:ek@enginkaya.com">ek@enginkaya.com</a></span>
                                </div>
                            </div>
                            <div className="col-lg-4">
                            <div className="info-item">
                                <i className="fa fa-map-marked"></i>
                                <h4>{translation("office-location")}</h4>
                                <span>Hofzeile 10-12/6/7<br />1190, Vienna / Austria</span>
                            </div>
                            </div>
                            <div className="col-lg-12">
                            <div id="contact" >
                                <div className="row">
                                <div className="col-lg-6">
                                    <fieldset>
                                        <input type="text" name="name" id="name" placeholder={translation("your-name")} autoComplete="" required
                                            value={mail.name} 
                                            onChange={(el) => setMail({...mail, name:el.target.value})}
                                        />
                                    </fieldset>
                                </div>
                                <div className="col-lg-6">
                                    <fieldset>
                                        <input type="text" name="telephone" id="telephone" placeholder={translation("your-telephone")} required 
                                            value={mail.phone}
                                            onChange={(el) => setMail({...mail, phone:el.target.value})}
                                        />
                                    </fieldset>
                                </div>
                                <div className="col-lg-6">
                                    <fieldset>
                                        <input type="email" name="email" id="email" placeholder={translation("your-e-mail")} required 
                                            value={mail.email}
                                            onChange={(el) => setMail({...mail, email:el.target.value})}
                                        />
                                    </fieldset>
                                </div>
                                <div className="col-lg-6">
                                    <fieldset>
                                        <input type="text" name="subject" id="subject" placeholder={translation("subject")} 
                                            value={mail.subject}
                                            onChange={(el) => setMail({...mail, subject:el.target.value})}
                                        />
                                    </fieldset>
                                </div>
                                <div className="col-lg-12">
                                    <fieldset>
                                        <textarea name="message" id="message" placeholder={translation("your-message")}
                                            value={mail.message}
                                            onChange={(el) => setMail({...mail, message:el.target.value})}
                                        ></textarea>
                                    </fieldset>
                                </div>
                                <div className="col-lg-12">
                                    <fieldset>
                                        <ReCAPTCHA
                                            ref={recaptcha}
                                            style={{ display: "inline-block" }}
                                            sitekey="6LfAc7cqAAAAAM1cifm29krYmbcHWh4Q_Pa9943D"
                                            onChange={onChange}
                                        />
                                    </fieldset>
                                </div>
                                <div className="col-lg-12">
                                    <fieldset>
                                        <button type="submit" id="form-submit" className="orange-button"
                                            onClick={() => sendMail()}
                                        >{translation("send-message-now")}</button>
                                    </fieldset>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </section>
                    </div>
                    
                </div>
            </div>
            <ToastContainer 
                style={{zIndex: 9999}}
                autoClose={5000}
                hideProgressBar={true}
                i18nIsDynamicList={true}
                position="bottom-right"

            />
        </div>
    )
}